<template>
  <v-content>
    <v-container grid-list-lg>
      <v-layout
        row
        wrap
      >
        <!-- errors -->
        <v-flex
          v-if="errors.length"
          xs12
        >
          <b>Please correct the following error(s):</b>
          <ul>
            <li
              v-for="error in errors"
              :key="error.id"
            >
              {{ error }}
            </li>
          </ul>
        </v-flex>

        <!-- user profile -->
        <v-flex
          xs12
          md4
        >
          <h2>プロフィール</h2>
          <v-card v-if="user">
            <v-card-text>
              <div>{{ user.data.name }}</div>
            </v-card-text>
          </v-card>
          <v-progress-circular
            v-else
            :size="50"
            color="primary"
            indeterminate
          />
        </v-flex>

        <!-- escape results -->
        <v-flex
          xs12
          md7
          offset-md1
        >
          <h2>脱出記録</h2>
          <v-card v-if="Array.isArray(results) && results.length > 0">
            <v-list
              subheader
            >
              <v-list-tile
                v-for="result in results"
                :key="result.id"
              >
                <v-list-tile-content>
                  <v-list-tile-title v-if="result.escape">
                    {{ result.escape.data.name }}
                  </v-list-tile-title>
                  <v-list-tile-title v-else>
                    情報取得中...
                  </v-list-tile-title>
                </v-list-tile-content>

                <v-spacer />

                <v-list-tile-action v-if="result.data.success">
                  <v-chip
                    color="teal"
                    text-color="white"
                  >
                    脱出成功
                  </v-chip>
                </v-list-tile-action>
              </v-list-tile>
            </v-list>
          </v-card>
          <div v-else-if="Array.isArray(results) && results.length == 0">
            <p>脱出履歴がありません。</p>
          </div>
          <v-progress-circular
            v-else
            :size="50"
            color="primary"
            indeterminate
          />
        </v-flex>
      </v-layout>

      <!-- 編集 -->
      <v-btn
        v-if="isMypage"
        right
        bottom
        fixed
        class="primary"
        @click="edit"
      >
        <v-icon dark>
          edit
        </v-icon>編集
      </v-btn>
    </v-container>
  </v-content>
</template>

<script>
import * as auth from "@/plugins/authenticate";
import * as http from "@/escape-be/http";
import UserRepository from "@/repository/user";
import ResultRepository from "@/repository/result";
import EscapeRepository from "@/repository/escape";
import firebase from "@/plugins/firebase";

export default {
  name: "UserShow",
  data() {
    return {
      isMypage: false,
      user: null,
      results: null,
      errors: []
    };
  },
  mounted: async function() {
    this.user = await UserRepository
      .findOne(this.$route.params.userId)
      .catch(e => this.errors.push(...[e].flat()));
    if(Array.isArray(this.errors) && this.errors.length > 0) return;

    this.results = await ResultRepository
      .findByUser(this.user)
      .catch(e => this.errors.push(...[e].flat()));
    if(Array.isArray(this.errors) && this.errors.length > 0) return;

    this.results.forEach(async r => {
      await EscapeRepository
        .findByRef(r.data.escapeRef)
        .then(e => this.$set(r, "escape", e))
        .catch(e => this.errors.push(...[e].flat()))
    }, this);
    if(Array.isArray(this.errors) && this.errors.length > 0) return;

    firebase.auth().onAuthStateChanged(user => {
      this.isMypage = user && user.uid == this.$route.params.userId;
    });
  },
  methods: {
    edit: function() {
      this.$router.push({ path: `/users/${this.$route.params.userId}/edit` });
    }
  }
};
</script>